import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
import messages from "../../../../utils/messages";
import serviceSaldoInstalacao from "../../../../services/serviceSaldoInstalacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: { open: boolean; id: string; quantidadeKW: string };
    onClose?: any;
}

export default function DialogEdit({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        quantidadeKW: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            quantidadeKW: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);

        const updateValues = {
            ...values,
            saldoInstalacaoID: data.id,
            quantidadeKW: values.quantidadeKW
                ? Number(values.quantidadeKW.replaceAll(".", "").replaceAll(",", "."))
                : 0,
        };

        serviceSaldoInstalacao
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Editar Saldo
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <InputNumber
                                name="quantidadeKW"
                                label="Quantidade Kilowatt"
                                control={control}
                                error={errors}
                                decimalScale={2}
                                maxLength={12}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
